import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const updateDocRejectProfile = React.createContext({});
export let updateDocRejectProfileMachine: any;

const MODULE_NAME = 'machines.updateProfile';

export const useSMupdateDocRejectProfile = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  updateDocRejectProfileMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(updateDocRejectProfileMachine);

  return {
    updateDocRejectProfileMachine,
    updateDocRejectProfileState: state,
    updateDocRejectProfileSend: send,
  };
};
